import * as Sentry from '@sentry/react';
import { ENV } from '../constants';
export function initializeSentry() {
    if (!ENV.SENTRY_DSN) {
        console.log('Sentry DSN not configured, skipping initialization');
        return;
    }
    Sentry.init({
        dsn: ENV.SENTRY_DSN,
        environment: process.env.NODE_ENV || 'development',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        // Performance Monitoring
        tracesSampleRate: 0.1, // Capture 10% of transactions for performance monitoring
        // Session Replay
        replaysSessionSampleRate: 0.1, // Sample 10% of sessions for replay
        replaysOnErrorSampleRate: 1.0, // Always capture replays when an error occurs
        // Filter out development errors
        beforeSend(event, hint) {
            // Don't send errors in development unless explicitly enabled
            if (process.env.NODE_ENV === 'development' && !process.env.SENTRY_DEV_ENABLED) {
                return null;
            }
            return event;
        },
    });
}
export { Sentry };
